import { render, staticRenderFns } from "./CustomerGroupHistory.vue?vue&type=template&id=538dc398&"
import script from "./CustomerGroupHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports